'use client';

import React, { useEffect, useRef, useState } from 'react';
import Image from 'next/image';

interface ServiceCard {
  img: string;
  alt: string;
  title: string;
  description: string;
  list?: string[];
}

export default function WhyUsSection() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {if (entry.isIntersecting) setVisible(true);},
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  const cards: ServiceCard[] = [
  {
    img: "/assets/images/hvac_maintenance_card.png",
    alt: 'Gorgis Air Conditioning & Heating technicians performing 38-point HVAC maintenance inspection',
    title: 'Maintenance',
    description:
    'Gorgis Air Conditioning and Heating is offering maintenance all year round, with 38 point inspection and cleaning. Ductwork Installation and Sealing, Zoned HVAC systems, Swamp/evaporate coolers and Tune-up. If you need heating or a new Furnace installation, give us a call. (619)-277-3287 or (619)-244-6693'
  },
  {
    img: "/assets/images/hvac_heating_card.png",
    alt: 'Gorgis Air Conditioning & Heating technician repairing residential furnace and heating system',
    title: 'Heating',
    description:
    'Heaters, furnaces and heat sources are our specialty. We can repair and service many styles and brands of heaters. We will also perform combustion analysis to make sure your heater is running safely and efficiently. If replacement is needed we offer a wide range of energy efficient models at a very affordable price. (619)-277-3287 or (619)-244-6693.'
  },
  {
    img: "/assets/images/hvac_cooling_card.png",
    alt: 'Gorgis Air Conditioning & Heating technician installing ductless mini-split AC system with company van outside',
    title: 'Cooling',
    description:
    'Central air conditioning system or package unit and mini-split — these units sit on the ground or rooftop outside of your home or business, or in the attic, on the ceiling or the wall. We can help you install, repair and maintain. If you need a new AC or furnace, give us a call. (619)-277-3287 or (619)-244-6693'
  },
  {
    img: "/assets/images/hvac_airquality_card.png",
    alt: 'Gorgis Air Conditioning & Heating technician installing air purification and UV light system for indoor air quality',
    title: 'Indoor Air Quality',
    description:
    'Does anyone in the home suffer from allergies or wake up with a scratchy throat or congestion? We offer various solutions:',
    list: [
    'Various types of air purification options',
    'Duct cleanings',
    'Merv filters',
    'Apco UV light',
    'Hypo allergen']

  }];


  return (
    <section id="why-us" ref={ref} className="py-20 bg-[#1e1e1e]">
      <div className="container mx-auto px-4">
        <div className="section-title pb-12">
          <h2>Why Us</h2>
          <p>Why Choose Gorgis Air Conditioning and Heating</p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {cards.map((card, i) =>
          <div
            key={card.title}
            className={`why-us-box rounded-lg transition-all duration-700 ${
            visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`
            }
            style={{ transitionDelay: `${i * 100}ms` }}>
            
              <Image
              src={card.img}
              alt={card.alt}
              width={100}
              height={100}
              className="mx-auto mb-4 object-contain" />
            
              <h4 className="text-center text-white/90 font-serif text-xl font-semibold uppercase mb-4">
                {card.title}
              </h4>
              <p className="text-[#aaaaaa] text-sm leading-relaxed">{card.description}</p>
              {card.list &&
            <ul className="mt-3 space-y-1">
                  {card.list.map((item) =>
              <li key={item} className="flex items-start gap-2 text-[#aaaaaa] text-sm">
                      <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 text-[#b5973a] flex-shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                      {item}
                    </li>
              )}
                </ul>
            }
            </div>
          )}
        </div>
      </div>
    </section>);

}